// eslint-disable-next-line no-restricted-imports
import { State } from 'modules';
// eslint-disable-next-line no-restricted-imports
import { ActionModel } from 'types/models';

export const getActionById = (
  state: State,
  idAction: string,
): ActionModel | undefined =>
  state.models.actions.find((action: ActionModel) => action.id === idAction);



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/actions.ts